import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $notes } from '../../Notes.store';
import SignModal from '../../ui/signModal/Sign.modal';
const SignButton = ({ buttonMode, setAttention }) => {
    const { t } = useTranslation();
    function handleSubmit(event) {
        if ($notes.beforeSignErrors.size)
            return setAttention === null || setAttention === void 0 ? void 0 : setAttention(true);
        $notes.validate();
        if ($notes.validateErrors.length) {
            $notes.SET_IS_SUBMITTED(true);
            if (!(event === null || event === void 0 ? void 0 : event.ctrlKey) && !(event === null || event === void 0 ? void 0 : event.metaKey))
                return;
        }
        $modal.add(SignModal);
    }
    return (_jsx(Button, Object.assign({ mode: buttonMode, onClick: handleSubmit }, { children: $notes.isChanged ? t('btn.sign_changes') : t('btn.sign_notes') })));
};
export default observer(SignButton);
